import { useQuery } from '@tanstack/react-query';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export interface Attraction {
  id: string;
  name: string;
  entityType: string;
  parkName?: string;
  externalId?: string;
  longitude?: number;
  latitude?: number;
  rating?: number;
  priority?: string;
}

// Only ATTRACTION and SHOW types should appear in analytics dropdown
const ALLOWED_ENTITY_TYPES = ['ATTRACTION', 'SHOW'] as const;

export function useAttractions(parkName: string | null) {
  return useQuery({
    queryKey: ['attractions', parkName],
    queryFn: async () => {
      if (!parkName) return [];
      const response = await fetch(`${API_BASE}/api/parks/${encodeURIComponent(parkName)}/attractions`);
      if (!response.ok) throw new Error(`Server error: ${response.status}`);
      const items = (await response.json()) as Partial<Attraction>[];
      // Only show ATTRACTION and SHOW entity types; RESTAURANT, STORE, etc. are noise
      return items
        .filter((item) => ALLOWED_ENTITY_TYPES.includes(item.entityType as 'ATTRACTION' | 'SHOW'))
        .map((item) => ({
          ...item,
          parkName: parkName, // API doesn't include parkName; derive from query param
        })) as Attraction[];
    },
    enabled: !!parkName,
    staleTime: 1000 * 60 * 2, // 2 min
  });
}
